import { Partner } from "../Partner";

export const BACKGROUND_COLOR_PARTNER_MAP = {
  [Partner.U_SWITCH]: "#F3F3F4",
  [Partner.EMMA]: "better-white",
  [Partner.NONE]: "better-white",
  [Partner.FORBES]: "better-white",
  [Partner.BRITISH_HOME_SELLERS]: "better-white",
};
